<template>
    <v-card style="border-radius: 20px;">
        <v-row>
            <v-col cols="5" sm="5" align="center" justify="center">
                <v-icon style="font-size: 96px;">mdi-account</v-icon>
            </v-col>
            <v-col cols="6" sm="6">
                <v-row align="center" justify="center">
                    <h3>{{title}}</h3>
                </v-row>
                <v-row class="fill-height">
                    <v-col align="center" justify="center">
                        <h1>{{content}}</h1>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        }
    },
    data(){
        return {

        }
    }
}
</script>